import React, { Component, forwardRef } from 'react';
import GridItem from 'components/Grid/GridItem';
import GridContainer from 'components/Grid/GridContainer';
import Card from 'components/Card/Card';
import CardHeader from 'components/Card/CardHeader';
import CardBody from 'components/Card/CardBody';
import { DataTable } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import { Column } from 'primereact/column';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import { isMobile } from 'react-device-detect';
import WizardGerente from 'views/WizardGerente/WizardGerente';
import { format } from 'date-fns';
import { MultiSelect } from 'primereact/multiselect';
import { Tooltip } from '@material-ui/core';
import BotaoMenu from './BotaoMenu';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'assets/scss/prime-table.scss';
import 'assets/css/prime-table.css';
import 'assets/css/documentos.css';
import 'assets/css/geral.css';
import 'assets/css/meus-pedidos.css';
import 'assets/css/pedidos-cirurgia.css';

import { dominioDemandaCirurgica } from '../../config/database';
import tr from 'date-fns/esm/locale/tr/index.js';

const tipoFiltroCirurgiasFuturas = 0;
const tipoFiltroTodasCirurgias = 1;

class PedidosCirurgia extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pedidosCirurgia: [],
      listaProcedimento: [],
      listaPrioridade: [],
      listaStatus: [],
      configuracoes: {},
      listaSLAs: [],
      listaCaracteresAtendimento: [],
      slaSelecionada: null,
      filtroCodigo: '',
      prioridadeSelecionada: '',
      caraterAtendimentoSelecionado: '',
      filtroPaciente: '',
      selectedDateInternacao: '',
      selectedDateSugerida: '',
      filtroEquipe: '',
      filtroProfissionalRequisitante: '',
      procedimentoSelecionado: '',
      statusSelecionado: '',
      loading: false,
      profissional: JSON.parse(localStorage.getItem('profissional')),
      renderWizardGerente: false,
      centrosCirurgicosFiltrados: JSON.parse(localStorage.getItem('profissional'))
        .centrosCirurgicos,
      botoesCentroCirurgico: [],
      disableRangeFilter: false,
      periodoFiltrado: null,
      listaConvenios: [],
      conveniosSelecionados: null,
      idsConveniosSelecionados: [],
      listaCampanhas: [],
      campanhasSelecionadas: null,
      idsCampanhasSelecionadas: [],
      campanhaRotina: { id: 0, nome: 'Rotina' },
      eOnco: '2',
    };
  }

  renderBotoesCentroCirurgico = () => {
    if (this.state.profissional.centrosCirurgicos.length <= 1) {
      this.setState({
        botoesCentroCirurgico: [],
      });
      return;
    }

    const botoes = [];
    dominioDemandaCirurgica.get('/api/centroCirurgico').then(response => {
      response.data.forEach(centroCirurgico => {
        if (this.state.profissional.centrosCirurgicos.includes(centroCirurgico.id))
          botoes.push({
            id: centroCirurgico.id,
            departamento: centroCirurgico.departamento,
          });
      });

      this.setState({
        botoesCentroCirurgico: botoes,
      });
    });
  };

  handleClickBotaoCentroCirurgico = centroCirurgico_id => {
    let { centrosCirurgicosFiltrados } = this.state;
    if (centrosCirurgicosFiltrados.includes(centroCirurgico_id)) {
      if (centrosCirurgicosFiltrados.length === 1) return;
      centrosCirurgicosFiltrados = centrosCirurgicosFiltrados.filter(
        id => id !== centroCirurgico_id
      );
    } else {
      centrosCirurgicosFiltrados.push(centroCirurgico_id);
    }

    /* this.listarPedidosCirurgia(
      centrosCirurgicosFiltrados,
      this.state.periodoFiltrado,
      this.state.idsConveniosSelecionados,
      this.state.idsCampanhasSelecionadas,
      this.state.eOnco
    ); */

    this.setState({ centrosCirurgicosFiltrados });
  };

  handleClickBotaoFiltroCirurgias = tipoFiltro => {
    this.setState({
      desabilitarBotaoCirurgiasFuturas: tipoFiltro === tipoFiltroCirurgiasFuturas,
      desabilitarBotaoTodasCirurgias: tipoFiltro === tipoFiltroTodasCirurgias,
    });

    if (tipoFiltro === tipoFiltroCirurgiasFuturas)
      this.setState({ filtroCirurgiaSelecionado: tipoFiltroCirurgiasFuturas });
    else if (tipoFiltro === tipoFiltroTodasCirurgias)
      this.setState({ filtroCirurgiaSelecionado: tipoFiltroTodasCirurgias });

    /* this.listarPedidosCirurgia(
      this.state.centrosCirurgicosFiltrados,
      tipoFiltro,
      this.state.idsConveniosSelecionados,
      this.state.idsCampanhasSelecionadas,
      this.state.eOnco
    ); */
  };

  getFiltrosPedidoCirurgia = () => {
    return {
      filtroCentroCirurgico: this.state.centrosCirurgicosFiltrados,
      periodoFiltrado: this.state.periodoFiltrado,
    };
  };

  handleOncologia = async () => {
    if (this.state.eOnco === '2') {
      await this.setState({ eOnco: '1' });
    } else {
      await this.setState({ eOnco: '2' });
    }

    /* await this.listarPedidosCirurgia(
      this.state.centrosCirurgicosFiltrados,
      this.state.periodoFiltrado,
      this.state.idsConveniosSelecionados,
      this.state.idsCampanhasSelecionadas,
      this.state.eOnco
    ); */
  };

  handleBuscarPedidos = async () => {
    await this.listarPedidosCirurgia(
      this.state.centrosCirurgicosFiltrados,
      this.state.periodoFiltrado,
      this.state.idsConveniosSelecionados,
      this.state.idsCampanhasSelecionadas,
      this.state.eOnco
    );
  };

  componentDidMount() {
    this.setPeriodoFiltradoInicial();
    this.listarProcedimentos();
    this.listarPrioridades();
    this.listarStatus();
    this.listarSLAs();
    this.listarCaracteresAtendimento();
    this.getConfiguracoes();
    this.renderBotoesCentroCirurgico();
    this.listarConvenios();
    this.listarCampanhas();
  }

  setPeriodoFiltradoInicial = () => {
    const configuracoes = JSON.parse(localStorage.getItem('configuracoes'));

    const dataInicio = new Date();
    const dataFim = new Date();
    dataFim.setDate(dataFim.getDate() + configuracoes.diasPeriodoFiltroPedidosCirurgia);

    const periodoFiltrado = [dataInicio, dataFim];

    this.setState({
      periodoFiltrado,
    });
    /* this.listarPedidosCirurgia(
      this.state.centrosCirurgicosFiltrados,
      periodoFiltrado,
      this.state.idsConveniosSelecionados,
      this.state.idsCampanhasSelecionadas,
      this.state.eOnco
    ); */
  };

  setRenderWizardGerente = valor => {
    this.setState({
      renderWizardGerente: valor,
    });
    document.location.href = `${document.location.href
      .replace('#goku', '')
      .replace('#centroMeusPedidos', '')}#goku`;
  };

  filterSLA(value, filter) {
    return value === filter.nome;
  }

  pedidosCirurgiaFiltrados = () => {
    let pedidosCirurgiaFiltrados = this.state.pedidosCirurgia;

    const {
      filtroCodigo,
      prioridadeSelecionada,
      caraterAtendimentoSelecionado,
      filtroPaciente,
      selectedDateInternacao,
      selectedDateSugerida,
      filtroEquipe,
      filtroProfissionalRequisitante,
      procedimentoSelecionado,
      statusSelecionado,
    } = this.state;

    if (filtroCodigo)
      pedidosCirurgiaFiltrados = pedidosCirurgiaFiltrados.filter(pedidoCirurgia =>
        pedidoCirurgia.codigo.includes(filtroCodigo)
      );

    if (prioridadeSelecionada)
      pedidosCirurgiaFiltrados = pedidosCirurgiaFiltrados.filter(
        pedidoCirurgia => pedidoCirurgia.prioridade === prioridadeSelecionada
      );

    if (caraterAtendimentoSelecionado)
      pedidosCirurgiaFiltrados = pedidosCirurgiaFiltrados.filter(
        pedidoCirurgia => pedidoCirurgia.nomeCaraterAtendimento === caraterAtendimentoSelecionado
      );

    if (filtroPaciente)
      pedidosCirurgiaFiltrados = pedidosCirurgiaFiltrados.filter(pedidoCirurgia =>
        this.converterFonetico(pedidoCirurgia.paciente.toUpperCase()).includes(
          this.converterFonetico(filtroPaciente.toUpperCase())
        )
      );

    if (selectedDateInternacao) {
      const filtro = new Date(selectedDateInternacao).toISOString().substring(0, 10);
      pedidosCirurgiaFiltrados = pedidosCirurgiaFiltrados.filter(pedidoCirurgia =>
        pedidoCirurgia.dataInternacao.includes(filtro)
      );
    }

    if (selectedDateSugerida) {
      const filtro = new Date(selectedDateSugerida).toISOString().substring(0, 10);
      pedidosCirurgiaFiltrados = pedidosCirurgiaFiltrados.filter(pedidoCirurgia =>
        pedidoCirurgia.dataCirurgia.includes(filtro)
      );
    }

    if (filtroEquipe)
      pedidosCirurgiaFiltrados = pedidosCirurgiaFiltrados.filter(pedidoCirurgia =>
        this.converterFonetico(pedidoCirurgia.equipeRequisitante.toUpperCase()).includes(
          this.converterFonetico(filtroEquipe.toUpperCase())
        )
      );

    if (filtroProfissionalRequisitante)
      pedidosCirurgiaFiltrados = pedidosCirurgiaFiltrados.filter(pedidoCirurgia =>
        this.converterFonetico(pedidoCirurgia.profissionalRequisitante.toUpperCase()).includes(
          this.converterFonetico(filtroProfissionalRequisitante.toUpperCase())
        )
      );

    if (procedimentoSelecionado)
      pedidosCirurgiaFiltrados = pedidosCirurgiaFiltrados.filter(
        pedidoCirurgia => pedidoCirurgia.procedimento === procedimentoSelecionado
      );

    if (statusSelecionado)
      pedidosCirurgiaFiltrados = pedidosCirurgiaFiltrados.filter(
        pedidoCirurgia => pedidoCirurgia.status === statusSelecionado
      );

    return pedidosCirurgiaFiltrados;
  };

  listarPedidosCirurgia = async (
    centrosCirurgicosFiltrados,
    periodoFiltrado,
    conveniosSelecionados,
    campanhasSelecionadas,
    eOnco
  ) => {
    this.setState({ loading: true });

    let dataInicioFormatada = null;
    let dataFimFormatada = null;

    if (periodoFiltrado) {
      if (periodoFiltrado[0]) dataInicioFormatada = format(periodoFiltrado[0], 'yyyy-MM-dd');
      if (periodoFiltrado[1]) dataFimFormatada = format(periodoFiltrado[1], 'yyyy-MM-dd');
    }

    const dados = {
      filtros: {
        centrosCirurgicos: centrosCirurgicosFiltrados.join(),
        dataInicio: dataInicioFormatada,
        dataFim: dataFimFormatada,
        convenios: conveniosSelecionados?.length > 0 ? conveniosSelecionados.join() : undefined,
        campanhas: campanhasSelecionadas?.length > 0 ? campanhasSelecionadas.join() : undefined,
        filtrarPedidosSemCampanha: campanhasSelecionadas?.includes(this.state.campanhaRotina.id)
          ? true
          : undefined,
        eOnco,
      },
    };

    this.setState({ disableRangeFilter: true });
    await dominioDemandaCirurgica.post(`/api/pedidoCirurgiaGerenteCentroCirurgico`, dados).then(
      res => {
        this.setState({
          pedidosCirurgia: res.data,
          loading: false,
          disableRangeFilter: false,
        });
      },
      () => {
        this.setState({
          loading: false,
          disableRangeFilter: false,
        });
      }
    );
  };

  calcularSLA(rowData) {
    const dataHoraAtual = new Date();
    const dataHoraAlertaSLA = new Date(rowData.dataHoraAlteracaoStatus);
    const dataHoraLimiteSLA = new Date(rowData.dataHoraAlteracaoStatus);
    const dataHoraAlteracaoStatus = new Date(rowData.dataHoraAlteracaoStatus);

    if (rowData.caraterAtendimento === this.state.configuracoes.caraterEletivo) {
      dataHoraAlertaSLA.setDate(dataHoraAlteracaoStatus.getDate() + rowData.prazoAlertaSLAEletivo);
      dataHoraLimiteSLA.setDate(dataHoraAlteracaoStatus.getDate() + rowData.prazoLimiteSLAEletivo);
    } else if (rowData.caraterAtendimento === this.state.configuracoes.caraterUrgencia) {
      dataHoraAlertaSLA.setDate(dataHoraAlteracaoStatus.getDate() + rowData.prazoAlertaSLAUrgencia);
      dataHoraLimiteSLA.setHours(
        dataHoraAlteracaoStatus.getHours() + rowData.prazoLimiteSLAUrgencia
      );
    }

    let nomeSLA = 'prazoNormal';

    if (rowData.prazoAlertaSLA !== null && rowData.prazoLimiteSLA !== null) {
      if (dataHoraAtual >= dataHoraLimiteSLA) {
        nomeSLA = 'prazoLimite';
      } else if (dataHoraAtual >= dataHoraAlertaSLA) {
        nomeSLA = 'prazoAlerta';
      }
    }
    return nomeSLA;
  }

  listarProcedimentos = () => {
    dominioDemandaCirurgica.get('/api/procedimentoCirurgico').then(response => {
      this.setState({ listaProcedimento: response.data.map(proc => proc.descricao) });
    });
  };

  listarPrioridades = () => {
    dominioDemandaCirurgica.get('/api/prioridadeCirurgia').then(response => {
      this.setState({ listaPrioridade: response.data });
    });
  };

  listarStatus = () => {
    dominioDemandaCirurgica.get('/api/statusPedido').then(response => {
      this.setState({ listaStatus: response.data.map(status => status.descricao) });
    });
  };

  listarSLAs = () => {
    const listaSLA = [
      {
        nome: 'prazoNormal',
        descricao: 'no prazo',
        cor: 'green',
        key: 1,
      },
      {
        nome: 'prazoAlerta',
        descricao: 'expirando',
        cor: 'gold',
        key: 2,
      },
      {
        nome: 'prazoLimite',
        descricao: 'fora do prazo',
        cor: 'red',
        key: 3,
      },
    ];

    this.setState({ listaSLAs: listaSLA });
  };

  listarCaracteresAtendimento = () => {
    dominioDemandaCirurgica.get('/api/caraterAtendimento').then(response => {
      this.setState({ listaCaracteresAtendimento: response.data.map(status => status.descricao) });
    });
  };

  listarConvenios = () => {
    dominioDemandaCirurgica.get('/api/convenio').then(response => {
      this.setState({ listaConvenios: response.data });
    });
  };

  listarCampanhas = () => {
    dominioDemandaCirurgica.get('/api/campanha').then(response => {
      this.setState({ listaCampanhas: [this.state.campanhaRotina, ...response.data] });
    });
  };

  getConfiguracoes = () => {
    this.setState({ configuracoes: JSON.parse(localStorage.getItem('configuracoes')) });
  };

  slaBodyTemplate = rowData => {
    let nomeSLA = 'prazoNormal';
    let corFundo = 'green';
    let corFonte = 'white';

    if (rowData.nomeSLA === 'prazoLimite') {
      nomeSLA = 'prazoLimite';
      corFundo = 'red';
      corFonte = 'white';
      // eslint-disable-next-line no-undef
    } else if (rowData.nomeSLA === 'prazoAlerta') {
      nomeSLA = 'prazoAlerta';
      corFundo = 'gold';
      corFonte = 'black';
    }

    return (
      <>
        <span className="p-column-title">SLA</span>
        <span
          name={rowData.codigo}
          className="bolinha-sla"
          style={{ backgroundColor: corFundo, color: corFonte }}
          InputText={nomeSLA}
        >
          SLA
        </span>
      </>
    );
  };

  codigoBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Nº Pedido</span>
        {rowData.pedidoSaudeSuplementar ? (
          <>
            <small
              className="sinalizacao-pedido-saude-suplementar"
              data-title={`Pedido de Saúde Suplementar\nConvênio: ${rowData.nomeConvenio}`}
            >
              CONVP
            </small>
            <br />
          </>
        ) : (
          <></>
        )}
        <span className={isMobile ? '' : 'fonte-ajustavel'}>{rowData.codigo}</span>
      </>
    );
  };

  pacienteBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Paciente</span>
        <div>
          {rowData.GMR === 'True' && <small className="sinalizacao-gmr">GMR</small>}
          {rowData.eOncologica === '1' && <small className="sinalizacao-oncologica">ONCO</small>}
        </div>
        <span className={isMobile ? '' : 'fonte-ajustavel'}>{rowData.paciente}</span>
      </>
    );
  };

  procedimentoBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Procedimento</span>
        <span className={isMobile ? '' : 'fonte-ajustavel'}>{rowData.procedimento}</span>
      </>
    );
  };

  equipeRequisitanteBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Equipe Requisitante</span>
        <span className={isMobile ? '' : 'fonte-ajustavel'}>{rowData.equipeRequisitante}</span>
      </>
    );
  };

  statusBodyTemplate = rowData => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        }}
      >
        <span className="bolinha-status" style={{ backgroundColor: rowData.corStatus }} />
        <span style={{ marginLeft: '20px' }}>{rowData.status}</span>
      </div>
    );
  };

  dataInternacaoBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Data Internação</span>
        <span className={isMobile ? '' : 'fonte-ajustavel'}>
          {rowData.dataInternacao
            ? new Date(rowData.dataInternacao).toLocaleString([], {
              day: '2-digit',
              month: '2-digit',
              year: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
            })
            : 'Não informado'}
        </span>
      </>
    );
  };

  dataSugeridaBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Data Cirurgia</span>
        <span className={isMobile ? '' : 'fonte-ajustavel'}>
          {new Date(rowData.dataCirurgia).toLocaleString([], {
            day: '2-digit',
            month: '2-digit',
            year: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
          })}
        </span>
      </>
    );
  };

  profissionalRequisitanteBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Profissional Requisitante</span>
        <span className={isMobile ? '' : 'fonte-ajustavel'}>
          {rowData.profissionalRequisitante}
        </span>
      </>
    );
  };

  acoesBodyTemplate = rowData => {
    const statusImpeditivos = [
      this.state.configuracoes.statusCancelado,
      this.state.configuracoes.statusFinalizado,
    ];

    const configuracoesRecursoSistema = JSON.parse(
      localStorage.getItem('configuracoesRecursoSistema')
    );

    const permiteConferencia = !statusImpeditivos.includes(rowData.status_id);

    return (
      <BotaoMenu
        rowData={rowData}
        configuracoes={this.state.configuracoes}
        configuracoesRecursoSistema={configuracoesRecursoSistema}
        listarPedidosCirurgia={this.listarPedidosCirurgia}
        listarStatus={this.listarStatus}
        getFiltrosPedidoCirurgia={this.getFiltrosPedidoCirurgia}
        profissionalObservador={this.state.profissional.acessoPedidosCirurgia === 'V'}
        setRenderWizardGerente={this.setRenderWizardGerente}
        permiteConferencia={permiteConferencia}
      />
    );
  };

  prioridadeBodyTemplate = rowData => {
    return (
      <div>
        <span className="p-column-title">Prioridade</span>
        <span
          className="bolinha-sla"
          style={{ backgroundColor: rowData.corPrioridade, color: 'white' }}
        >
          <strong>{rowData.codigoPrioridade}</strong>
        </span>
      </div>
    );
  };

  caraterBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Caráter de Atendimento</span>
        <span className={isMobile ? '' : 'fonte-ajustavel'}>{rowData.nomeCaraterAtendimento}</span>
      </>
    );
  };

  converterFonetico = string => {
    let novaString = string;

    //  Remoção de acentuação
    novaString = novaString.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

    //  Remoção de letras duplas
    let caracterAnterior = '';
    let stringAuxiliar = '';
    for (const caracter of novaString) {
      if (caracter !== caracterAnterior) {
        stringAuxiliar += caracter;
      }
      caracterAnterior = caracter;
    }

    // Som de S
    novaString = novaString.replace(/Ç/g, 'S');
    novaString = novaString.replace(/Z/g, 'S');
    novaString = novaString.replace(/X/g, 'S');
    novaString = novaString.replace(/CE/g, 'SE');
    novaString = novaString.replace(/CI/g, 'SI');

    // Som de K
    novaString = novaString.replace(/CA/g, 'KA');
    novaString = novaString.replace(/CO/g, 'KO');
    novaString = novaString.replace(/CU/g, 'KU');
    novaString = novaString.replace(/QU/g, 'K');

    // Som de I
    novaString = novaString.replace(/Y/g, 'I');

    // Som de F
    novaString = novaString.replace(/PH/g, 'F');

    // Som de J
    novaString = novaString.replace(/GE/g, 'JE');
    novaString = novaString.replace(/GI/g, 'JI');

    // Som de G
    novaString = novaString.replace(/GU/g, 'G');

    // Som de M
    novaString = novaString.replace(/N/g, 'M');

    // Som de V
    novaString = novaString.replace(/W/g, 'U');

    return novaString;
  };

  customFilterFonetico = (value, filter) => {
    return this.converterFonetico(value.toUpperCase()).includes(
      this.converterFonetico(filter.toUpperCase())
    );
  };

  render() {
    //  #region componentes
    const pt = {
      firstDayOfWeek: 1,
      dayNames: ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'],
      dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
      dayNamesMin: ['DO', 'SE', 'TE', 'QA', 'QI', 'SX', 'SA'],
      monthNames: [
        'janeiro',
        'fevereiro',
        'março',
        'abril',
        'maio',
        'junho',
        'julho',
        'agosto',
        'setembro',
        'outubro',
        'novembro',
        'dezembro',
      ],
      monthNamesShort: [
        'jan',
        'fev',
        'mar',
        'abr',
        'mai',
        'jun',
        'jul',
        'ago',
        'set',
        'out',
        'nov',
        'dez',
      ],
      today: 'Hoje',
      clear: 'Limpar',
      dateFormat: 'dd/mm/yy',
      weekHeader: 'Sm',
    };

    const dateInternacaoFilter = (
      <Calendar
        locale={pt}
        value={this.state.selectedDateInternacao}
        onChange={e => {
          this.setState({ selectedDateInternacao: e.value });
        }}
        dateFormat="dd/mm/yy"
        className="p-column-filter"
        placeholder="Data"
        showButtonBar
      />
    );

    const dateSugeridaFilter = (
      <Calendar
        locale={pt}
        value={this.state.selectedDateSugerida}
        onChange={e => {
          this.setState({ selectedDateSugerida: e.value });
        }}
        dateFormat="dd/mm/yy"
        className="p-column-filter"
        placeholder="Data"
        showButtonBar
      />
    );

    const slaFilter = (
      <Autocomplete
        id="filtroSLA"
        options={this.state.listaSLAs}
        getOptionLabel={option => `${option}`}
        onChange={(e, value) => {
          this.setState({ slaSelecionada: value });
          this.dt.filter(value, 'nomeSLA', 'custom');
        }}
        value={
          this.state.slaSelecionada
            ? this.state.slaSelecionada.descricao
            : this.state.slaSelecionada
        }
        filterSelectedOptions
        renderInput={params => <TextField {...params} label="SLA" variant="outlined" />}
        renderOption={(props, option) => {
          return (
            <div className="div-item-prioridade">
              <span {...props} className="bolinha-sla" style={{ backgroundColor: option.cor }}>
                {option.descricao}
              </span>
            </div>
          );
        }}
      />
    );

    const prioridadeFilter = (
      <Autocomplete
        id="filtroPrioridade"
        options={this.state.listaPrioridade}
        getOptionLabel={option => `${option}`}
        onChange={(e, value) => {
          if (value != null) {
            this.setState({ prioridadeSelecionada: value.descricao });
          } else {
            this.setState({ prioridadeSelecionada: value });
          }
        }}
        value={this.state.prioridadeSelecionada}
        filterSelectedOptions
        renderInput={params => <TextField {...params} label="Priori" variant="outlined" />}
        renderOption={(props, option) => {
          return (
            <div {...props} className="div-item-prioridade div-filtro-prioridade">
              <span className="bolinha-prioridade" style={{ backgroundColor: option.cor }} />
            </div>
          );
        }}
      />
    );

    const procedimentosFilter = (
      <Autocomplete
        id="filtroProcedimento"
        options={this.state.listaProcedimento}
        getOptionLabel={option => `${option}`}
        onChange={(e, value) => {
          this.setState({ procedimentoSelecionado: value });
        }}
        value={this.state.procedimentoSelecionado}
        filterSelectedOptions
        renderInput={params => <TextField {...params} label="Proc" variant="outlined" />}
      />
    );

    const statusFilter = (
      <Autocomplete
        options={this.state.listaStatus}
        getOptionLabel={option => `${option}`}
        onChange={(e, value) => {
          this.setState({ statusSelecionado: value });
        }}
        value={this.state.statusSelecionado}
        filterSelectedOptions
        renderInput={params => <TextField {...params} label="Status" variant="outlined" />}
      />
    );

    const codigoFilter = (
      <TextField
        className="filtro-textfield-pedidogerente"
        value={this.state.filtroCodigo}
        onChange={e => {
          this.setState({ filtroCodigo: e.target.value });
        }}
        variant="outlined"
        label="Nº"
      />
    );

    const pacienteFilter = (
      <TextField
        className="filtro-textfield-pedidogerente"
        onChange={e => {
          this.setState({ filtroPaciente: e.target.value });
        }}
        value={this.state.filtroPaciente}
        variant="outlined"
        label="Paciente"
      />
    );

    const profissionalFilter = (
      <TextField
        className="filtro-textfield-pedidogerente"
        onChange={e => {
          this.setState({ filtroProfissionalRequisitante: e.target.value });
        }}
        value={this.state.filtroProfissionalRequisitante}
        variant="outlined"
        label="Requi"
      />
    );

    const equipeFilter = (
      <TextField
        className="filtro-textfield-pedidogerente"
        onChange={e => {
          this.setState({ filtroEquipe: e.target.value });
        }}
        value={this.state.filtroEquipe}
        variant="outlined"
        label="Equipe"
      />
    );

    const caraterAtendimentoFilter = (
      <Autocomplete
        id="filtroCaraterAtendimento"
        options={this.state.listaCaracteresAtendimento}
        getOptionLabel={option => `${option}`}
        onChange={(e, value) => {
          this.setState({ caraterAtendimentoSelecionado: value });
        }}
        value={this.state.caraterAtendimentoSelecionado}
        filterSelectedOptions
        renderInput={params => <TextField {...params} label="Caráter" variant="outlined" />}
      />
    );

    const header = (
      <>
        <div className="table-header campo-filtro">
          <span className="p-input-icon-left">
            <i className="pi pi-search" />
            <InputText
              type="search"
              onInput={e => this.setState({ globalFilter: e.target.value })}
              placeholder="Pesquise pela descrição dos campos..."
              style={{ width: '78vw', height: '6vh' }}
            />
          </span>
        </div>
      </>
    );

    //  #endregion

    if (this.state.renderWizardGerente)
      return (
        <WizardGerente
          setRenderWizardGerente={this.setRenderWizardGerente}
          listarPedidosCirurgia={this.listarPedidosCirurgia}
          getFiltrosPedidoCirurgia={this.getFiltrosPedidoCirurgia}
        />
      );

    return (
      <div>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={12}>
            <br />
            <div className="grupo-botoes-filtros">
              <div>
                <label
                  htmlFor="filtroPeriodoDataCirurgia"
                  style={{
                    display: 'block',
                    fontSize: '1vw',
                    color: 'black',
                  }}
                >
                  Periodo da Data de Cirurgia
                </label>
                <Calendar
                  id="filtroPeriodoDataCirurgia"
                  locale={pt}
                  value={this.state.periodoFiltrado}
                  onChange={async e => {
                    /* await this.listarPedidosCirurgia(
                      this.state.centrosCirurgicosFiltrados,
                      e.value,
                      this.state.idsConveniosSelecionados,
                      this.state.idsCampanhasSelecionadas,
                      this.state.eOnco
                    ); */
                    this.setState({ periodoFiltrado: e.value });
                  }}
                  disabled={this.state.disableRangeFilter}
                  dateFormat="dd/mm/yy"
                  selectionMode="range"
                  readOnlyInput
                  showIcon
                  showButtonBar
                  style={{
                    width: '20vw',
                  }}
                />
              </div>
              <div className="div-botoes-filtros">
                <div className="div-botoes-filtro-centro-cirurgico">
                  <span className="p-buttonset">
                    {this.state.botoesCentroCirurgico.map(botao => (
                      <Button
                        label={botao.departamento}
                        key={botao.id}
                        onClick={() => this.handleClickBotaoCentroCirurgico(botao.id)}
                        className={
                          this.state.centrosCirurgicosFiltrados.some(
                            idCentroCirurgico => idCentroCirurgico === botao.id
                          )
                            ? ''
                            : 'botao-filtro-desabilitado'
                        }
                      />
                    ))}
                  </span>
                </div>
              </div>
              <div className="div-selecao-convenios-filtro">
                <MultiSelect
                  value={this.state.conveniosSelecionados}
                  options={this.state.listaConvenios}
                  optionLabel="descricao"
                  placeholder="Selecione um convênio"
                  maxSelectedLabels={4}
                  onChange={e => {
                    this.setState({ conveniosSelecionados: e.value }, () => {
                      const { conveniosSelecionados } = this.state;
                      if (conveniosSelecionados && conveniosSelecionados.length > 0) {
                        this.setState(
                          {
                            idsConveniosSelecionados: conveniosSelecionados.map(
                              convenio => convenio.id
                            ),
                          }/*,
                          () =>
                            this.listarPedidosCirurgia(
                              this.state.centrosCirurgicosFiltrados,
                              this.state.periodoFiltrado,
                              this.state.idsConveniosSelecionados,
                              this.state.idsCampanhasSelecionadas,
                              this.state.eOnco
                            ) */
                        );
                      } else {
                        this.setState({ idsConveniosSelecionados: [] }/*, () =>
                          this.listarPedidosCirurgia(
                            this.state.centrosCirurgicosFiltrados,
                            this.state.periodoFiltrado,
                            this.state.idsConveniosSelecionados,
                            this.state.idsCampanhasSelecionadas,
                            this.state.eOnco
                          ) */
                        );
                      }
                    });
                  }}
                />
              </div>
              <div className="div-selecao-campanha-filtro">
                <MultiSelect
                  value={this.state.campanhasSelecionadas}
                  options={this.state.listaCampanhas}
                  optionLabel="nome"
                  placeholder="Selecione uma campanha"
                  maxSelectedLabels={this.state.listaCampanhas.length}
                  onChange={e => {
                    this.setState({ campanhasSelecionadas: e.value }, () => {
                      const { campanhasSelecionadas } = this.state;
                      if (campanhasSelecionadas && campanhasSelecionadas.length > 0) {
                        if (
                          campanhasSelecionadas[campanhasSelecionadas.length - 1].id !==
                          this.state.campanhaRotina.id
                        ) {
                          const campanhasSemRotina = campanhasSelecionadas.filter(
                            campanha => campanha.id !== this.state.campanhaRotina.id
                          );
                          this.setState(
                            {
                              campanhasSelecionadas: campanhasSemRotina,
                              idsCampanhasSelecionadas: campanhasSemRotina.map(
                                campanha => campanha.id
                              ),
                            }/*,
                            () =>
                              this.listarPedidosCirurgia(
                                this.state.centrosCirurgicosFiltrados,
                                this.state.periodoFiltrado,
                                this.state.idsConveniosSelecionados,
                                this.state.idsCampanhasSelecionadas,
                                this.state.eOnco
                              ) */
                          );
                        } else
                          this.setState(
                            {
                              campanhasSelecionadas: [this.state.campanhaRotina],
                              idsCampanhasSelecionadas: [this.state.campanhaRotina.id],
                            }/*,
                            () =>
                              this.listarPedidosCirurgia(
                                this.state.centrosCirurgicosFiltrados,
                                this.state.periodoFiltrado,
                                this.state.idsConveniosSelecionados,
                                this.state.idsCampanhasSelecionadas,
                                this.state.eOnco
                              ) */
                          );
                      } else {
                        this.setState({ idsCampanhasSelecionadas: [] }/*, () =>
                          this.listarPedidosCirurgia(
                            this.state.centrosCirurgicosFiltrados,
                            this.state.periodoFiltrado,
                            this.state.idsConveniosSelecionados,
                            this.state.idsCampanhasSelecionadas,
                            this.state.eOnco
                          ) */
                        );
                      }
                    });
                  }}
                />
                <Button
                  label="ONCO"
                  key={1}
                  className={
                    this.state.eOnco === '1' ? 'button-oncologia' : 'button-oncologia-desabilitado'
                  }
                  onClick={this.handleOncologia}
                />
                <Button
                  label="Buscar"
                  key="buscar"
                  className="button-buscar"
                  icon="pi pi-search"
                  onClick={this.handleBuscarPedidos}
                />
              </div>
            </div>
            <Card>
              <CardHeader color="rose" id="centroMeusPedidos" className="card-header">
                <Grid container spacing={3}>
                  <Grid item xs={6}>
                    <p className="card-title">
                      <strong>Pedidos de Cirurgias</strong>
                    </p>
                  </Grid>
                </Grid>
              </CardHeader>
              <CardBody className="card-body-0-padding">
                <div id="table-pedidos-cirurgia" className="datatable">
                  <div className="card">
                    <DataTable
                      ref={el => {
                        this.dt = el;
                      }}
                      value={this.pedidosCirurgiaFiltrados()}
                      paginator
                      header={header}
                      globalFilter={this.state.globalFilter}
                      rows={10}
                      className="p-datatable-prime"
                      emptyMessage="Sem pedidos"
                      loading={this.state.loading}
                      first={this.state.first}
                      onPage={e => {
                        this.setState({ first: e.first });
                        document.location.href = `${document.location.href
                          .replace('#centroMeusPedidos', '')
                          .replace('#goku', '')}#centroMeusPedidos`;
                      }}
                    >
                      {/* <Column
                        field="nomeSLA"
                        header="SLA"
                        body={this.slaBodyTemplate}
                        filter
                        filterPlaceholder="SLA"
                        filterElement={slaFilter}
                        filterFunction={this.filterSLA}
                        headerStyle={{ width: '6,5%' }}
                        filterHeaderClassName="select-table-header"
                      /> */}
                      <Column
                        field="codigo"
                        header="Nº Pedido"
                        sortable
                        body={this.codigoBodyTemplate}
                        filter
                        headerStyle={{ width: '8%' }}
                        headerClassName={isMobile ? '' : 'fonte-ajustavel'}
                        filterElement={codigoFilter}
                        filterHeaderClassName="select-table-header"
                      />
                      <Column
                        field="prioridade"
                        header="Prioridade"
                        sortable
                        body={this.prioridadeBodyTemplate}
                        filter
                        filterElement={prioridadeFilter}
                        headerStyle={{ width: '6,5%' }}
                        headerClassName={isMobile ? '' : 'fonte-ajustavel'}
                        filterHeaderClassName="select-table-header"
                      />
                      <Column
                        field="nomeCaraterAtendimento"
                        header="Caráter"
                        sortable
                        body={this.caraterBodyTemplate}
                        filter
                        filterElement={caraterAtendimentoFilter}
                        headerStyle={{ width: '8%' }}
                        headerClassName={isMobile ? '' : 'fonte-ajustavel'}
                        filterHeaderClassName="select-table-header"
                      />
                      <Column
                        field="paciente"
                        header="Paciente"
                        sortable
                        body={this.pacienteBodyTemplate}
                        filter
                        filterElement={pacienteFilter}
                        headerStyle={{ width: '11%' }}
                        headerClassName={isMobile ? '' : 'fonte-ajustavel'}
                        filterHeaderClassName="select-table-header"
                      />
                      <Column
                        field="dataInternacao"
                        header="Data Internação"
                        sortable
                        body={this.dataInternacaoBodyTemplate}
                        filter
                        filterElement={dateInternacaoFilter}
                        headerStyle={{ width: '9%' }}
                        headerClassName={isMobile ? '' : 'fonte-ajustavel'}
                        filterHeaderClassName="select-table-header"
                      />
                      <Column
                        field="dataCirurgia"
                        header="Data Cirurgia"
                        sortable
                        body={this.dataSugeridaBodyTemplate}
                        filter
                        filterElement={dateSugeridaFilter}
                        headerStyle={{ width: '9%' }}
                        headerClassName={isMobile ? '' : 'fonte-ajustavel'}
                        filterHeaderClassName="select-table-header"
                      />
                      <Column
                        field="equipeRequisitante"
                        header="Equipe"
                        sortable
                        body={this.equipeRequisitanteBodyTemplate}
                        filter
                        filterElement={equipeFilter}
                        headerStyle={{ width: '9%' }}
                        headerClassName={isMobile ? '' : 'fonte-ajustavel'}
                        filterHeaderClassName="select-table-header"
                      />
                      <Column
                        field="profissionalRequisitante"
                        header="Requisitante"
                        sortable
                        body={this.profissionalRequisitanteBodyTemplate}
                        filter
                        filterElement={profissionalFilter}
                        headerStyle={{ width: '12%' }}
                        headerClassName={isMobile ? '' : 'fonte-ajustavel'}
                        filterHeaderClassName="select-table-header"
                      />
                      <Column
                        field="procedimento"
                        header="Procedimento"
                        sortable
                        body={this.procedimentoBodyTemplate}
                        filter
                        filterElement={procedimentosFilter}
                        headerStyle={{ width: '10%' }}
                        headerClassName={isMobile ? '' : 'fonte-ajustavel'}
                        filterHeaderClassName="select-table-header"
                      />
                      <Column
                        field="status"
                        header="Status"
                        sortable
                        body={this.statusBodyTemplate}
                        filter
                        filterElement={statusFilter}
                        headerStyle={{ width: '10%' }}
                        headerClassName={isMobile ? '' : 'fonte-ajustavel'}
                        filterHeaderClassName="select-table-header"
                      />
                      <Column
                        header="Ações"
                        body={this.acoesBodyTemplate}
                        filterHeaderClassName="select-table-header"
                        headerStyle={{ textAlign: 'center', width: '7,5%' }}
                        headerClassName={isMobile ? '' : 'fonte-ajustavel'}
                      />
                    </DataTable>
                  </div>
                </div>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default PedidosCirurgia;
